import actions from "@/store/actions/dialog/dialogAction";
import mutations from "@/store/mutations/diaLogMutation";
import getters from "@/store/getters/dialogGetter";
/**
 * Dialog
 */
export default {
  actions,
  state: {
    liteSearchShow: false,
    retainDialogShow: false
  },
  mutations,
  getters
};
